/// <amd-module name="Wit/WorkItemForm/Common/RoutingUtils" />
import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { safeSubstring } from "VSS/Core/Util/String";

const workItemFormRoute = "ms.vss-work-web.new-work-item-form-route";
const WorkItemsHubRouteId = "ms.vss-work-web.new-work-items-hub-view-route";
const TrimmedWorkItemEditorLength = 128;

export function getWorkItemFormTitle(workItem: IWorkItem) {
    var caption, title;

    if (workItem) {
        caption = workItem.getCaption({ includeDirtyModifier: true });
        title = workItem.getTitle();

        if (title && title.length > TrimmedWorkItemEditorLength) {
            title = safeSubstring(title, 0, TrimmedWorkItemEditorLength) + "...";
        }

        return `${caption} ${title}`;
    }

    return "";
}

export function getWorkItemEditUrl(pageContext: IVssPageContext, workItemId: string) {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues = {
        project: projectName || "",
        id: workItemId
    };
    return routeUrl(pageContext, workItemFormRoute, routeValues);
}

export function isNewWorkItemFormRoute(pageContext: IVssPageContext): boolean {
    return pageContext.getService<IVssNavigationService>("IVssNavigationService").getCurrentRoute().routeId === workItemFormRoute;
}

/**
 * Gets the URL for the workitem hub
 */
export function getWorkItemHubUrl(pageContext: IVssPageContext): string {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues = {
        project: projectName || ""
    };
    return routeUrl(pageContext, WorkItemsHubRouteId, routeValues);
}
